import React from 'react';
import { IIconProps } from './IIconProps';

export const RepeatIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 14 14"
			className={iconClass}
		>
			{title && <title>{title}</title>}
			<path d="M9.91675 0.583313L12.2501 2.91665L9.91675 5.24998" />
			<path d="M1.75 6.41669V5.25002C1.75 3.96136 2.79467 2.91669 4.08333 2.91669H12.25" />
			<path d="M4.08333 13.4167L1.75 11.0833L4.08333 8.75" />
			<path d="M12.25 7.58331V8.74998C12.25 10.0386 11.2053 11.0833 9.91667 11.0833H1.75" />
		</svg>
	);
};
